export function formatDistance(metters){
    if(metters < 1000){
        return metters + 'm';
    }
    return Math.round(metters / 1000) + 'km';
}
